<template>
  <div class="literature">
    <div class="literature_component">
      <div class="columns">
        <div class="column is-8">
          <h2 class="literature_title">{{title}}</h2>
          <p class="literature_author">{{author}}</p>
          <div class="main_text_component">
            <div class="main_text_area">
              <p class="main_text_before" v-if="support_text && read_number > 0" v-html="this.text[read_number -1]"></p>
              <p class="main_text_center" v-html="this.text[read_number]"></p>
              <p class="main_text_after" v-if="support_text" v-html="this.text[read_number + 1]"></p>
            </div>
          </div>
          <div class="main_button_component">
          <b-button @click="countDown" v-if="!timerOn"><span class="icon-step-backward"></span></b-button>
          <b-button @click="countDown" v-if="timerOn" disabled><span class="icon-step-backward"></span></b-button>
          <b-button @click="autoCountUp" v-if="!timerOn"><span class="icon-play"></span></b-button>
          <b-button @click="stopAutoCountUp" v-if="timerOn"><span class="icon-pause"></span></b-button>
          <b-button @click="countUp" v-if="!timerOn"><span class="icon-step-forward"></span></b-button>
          <b-button @click="countUp" v-if="timerOn" disabled><span class="icon-step-forward"></span></b-button>
          </div>
          <hr/>
          <div class="slider">
            <p><strong>表示速度</strong> {{this.value / 10}}秒</p>
            <b-field v-if="!timerOn">
              <b-slider :min="1" :max="10" v-model="value"></b-slider>
            </b-field>
            <b-field v-if="timerOn">
              <b-slider :min="1" :max="10" v-model="value" disabled></b-slider>
            </b-field>
            <p class="progress_info">
              <b-tooltip label="読了の目安" position="is-bottom">
                <span class="icon-clock-o"></span> {{Math.floor((this.text.length - this.read_number) / (600 / this.value)) }} min
              </b-tooltip>
              <span>（{{this.read_number}}/{{this.text.length}}）</span>
            </p>
          <hr/>
            <b-button v-if="!this.support_text" @click="supportText">前後を表示</b-button>
            <b-button v-if="this.support_text" @click="supportText">前後を非表示</b-button>
          </div>
          <div class="is-hidden-mobile">
            <div class="display_button">
              <b-button v-if="!this.display_text" @click="displayText">全文を表示</b-button>
              <b-button v-if="this.display_text" @click="displayText">全文を非表示</b-button>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="side_component">
            <h3>作品</h3>
            <div class="literature_info">
              <div class="literature_info_img">
                <img :src="this.image_url" alt="">
              </div>
              <p>{{this.author}}</p>
              <p>{{this.title}}</p>
              <p class="amazon_link_component">
                <a :href="this.amazon_link">
                <span class="icon-amazon icon_amazon"></span>
                 amazonで見る
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr/>
      <div v-if="display_text" class="text_text">
        <span v-for="(t, index) in text" :key="index">
          <span v-if="index != read_number" @click="moveText(index)" v-html="t"></span>
          <span class="text_text_red" v-if="index == read_number" @click="moveText(index)" v-html="t"></span>
          <span v-if="t.indexOf('。') != -1"><br><br></span>
        </span>
      </div>

    <!-- モーダルウィンドウ -->
    <section>
      <b-modal v-model="isCardModalActive" :width="500">
        <div class="card">
          <header class="modal-card-head">
            <p class="modal-card-title">読みました!</p>
          </header>
          <div class="card-image">
            <figure class="image container is-128x128">
              <img alt="party_popper" src="../assets/party_popper.png">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="subtitle is-6">{{this.author}}</p>
                <p class="title is-4">{{this.title}}</p>
                <p>{{this.total_character_count}}文字</p>
              </div>
            </div>

            <div class="content">
              {{this.author}}「{{this.title}}」を全て読みました！おめでとうございます！
              <p><b-button @click="twitterShare"><span class="icon-twitter modal_icon_twitter"></span>シェア</b-button></p>
            </div>
          </div>
          <footer class="modal-card-foot">
            <span class="container">
            <button class="button is-small" @click="closeModal">閉じる</button>
            </span>
          </footer>
        </div>
      </b-modal>
    </section>
    </div>
  </div>

</template>

<script>
// import mikan from 'mikanjs';
export default {
  data(){
    return{
      read_number: 0,
      title: '',
      author: '',
      image_url: '',
      amazon_link: '',
      total_character_count: '',
      text : [],
      text_list : [],
      already_read_text:[],
      isRed: false,
      value: 4,
      timerOn: false,
      timerObj: [],
      support_text: false,
      isCardModalActive: false,
      display_text: false
    }
  },
  created(){
    const row_text = require('../json_file/literature/' + this.$route.params.id + '.json')
    this.title = row_text.title
    this.author = row_text.author
    this.image_url = row_text.url
    this.amazon_link = row_text.amazon_link
    this.text = row_text.main_text
    this.text_list = row_text.main_text
    this.total_character_count = row_text.total_character_count
    this.betterRender()
  },
  mounted(){
    const title = this.title + "｜Flatte"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
  },
  computed: {
    classObject: function() {
      return {
        colorRed: this.isRed === true,
        fontBold: this.isBold === true
      }
    }
  },
  watch:{
    isCardModalActive(val){
      if(val == true){
        this.$confetti.start();
      }else{
        this.$confetti.stop();
      }

    }
  },
  methods:{
    countUp(){
      this.read_number ++;
    },
    countDown(){
      if(0 < this.read_number){
        this.read_number --;
      }
    },
    autoCountUp(){
      this.timerObj = setInterval(() => {
        if(this.read_number >= this.text.length){
          clearInterval(this.timerObj);
          setTimeout(() => {
            this.timerOn = false;
            this.read_number = 0
            this.isCardModalActive = true;
              }
            ,600
          )
        }else{
          this.read_number ++
        }
        }
        ,this.value * 100
      )
      this.timerOn = true;
    },
    stopAutoCountUp(){
      clearInterval(this.timerObj);
      this.timerOn = false;
    },
    supportText(){
      this.support_text = !this.support_text
    },
    moveText(index){
      this.read_number = index
    },
    closeModal(){
      this.isCardModalActive = false;
    },
    twitterShare(){
      var twitter_share_url = 'https://twitter.com/intent/tweet?text=' +this.author + "「" + this.title + "」" +  "を読みました！" + "%20%23Flatte" + "%20" + "https://flatte.ameneko.com/literature/" +  this.$route.params.id 
      window.open(twitter_share_url, '_blank')  
    },
    displayText(){
      this.display_text = !this.display_text
    },
    betterRender() {
      const self = this;
      self.text_list = [];
      const text = self.text_list;
      const ite = function*() {
        // NOTE: 100アイテムづつsetTimeoutでレンダリング
        while (true) {
          const items = text.splice(0, 100); // Get items 100 by 100
          if (items.length <= 0) break;
          yield setTimeout(() => {
            for (let len = items.length, i = 0; i < len; i++) {
              const item = items[i]
              self.text.push(item);
            }
            ite.next();
          });
        }
      }();
      ite.next();
    },
  }
}
</script>

<style>
h2{
    font-weight: bold;
    display: block;
    font-size: 1.17em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
h3{
    font-weight: bold;
    display: block;
    font-size: 1.1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
hr{
  margin:24px 0;
}
.literature{
  background-color: #F1F5F9;
}
.literature_title{
    font-size:1.8em;
    text-align: center;
}
.literature_author{
  text-align: center;
}
.button{
  margin: 0 8px;
}
.literature_component{
    max-width: 1120px;
    margin: 0px auto;
    padding: 48px 16px;
}
.main_text_component{
  background-color: #F8F8F8;
  border-radius: 0.5em;
  padding-bottom:16px;
  margin-top:20px;
  margin-bottom: 20px;
}
.main_text_area{
  font-size:1.13em;
  max-width: 320px;
  margin: auto;
  padding: 70px 0 50px 70px;
  position:relative;
}
.main_text_center{
position:absolute;
bottom:40px;
left:0px
}
.main_text_before{
position:absolute;
bottom:80px;
left:0px;
color:gray
}
.main_text_after{
position:absolute;
bottom:0px;
left:0px;
color:gray
}
.main_button_component{
  text-align: center;
}
.colorRed{ 
  color: red
  }
.slider{
  max-width: 320px;
}
.text_text_red{
  color: red;
}
.text_text{
  padding: 16px;
  background-color: white;
  border-radius: 0.5em;
}
.modal-background {
    background-color: rgba(0,0,0,0.35);
}
.card{
  text-align: center;
  border-radius: 0.5em;
}
.card-image{
  margin-top:10px;
}
.modal-card-foot{
  padding: 16px 0;
}
.modal_icon_twitter{
  font-size: 1.1rem;
  color: #1EA1F1;
  vertical-align: text-bottom;
}
rt{
  font-size: 12px;
}
.progress_info{
  color: gray;
}
.side_component{
  border-radius: 0.5em;
  padding: 16px;
  background-color: #F8F8F8;
}
.literature_info{
  padding:24px;
  font-weight: bold;
}
.literature_info_img{
  text-align: center;
}
.amazon_link_component{
  padding: 16px 0;
  font-size: 0.9rem;
}
.icon_amazon{
  vertical-align: text-bottom;
}
.display_button{
  margin: 16px 0;
}
</style>
